import { defineComponent as m, computed as u, resolveComponent as i, openBlock as t, createElementBlock as d, normalizeClass as g, createBlock as n, createCommentVNode as o, withCtx as S, createTextVNode as f, toDisplayString as y } from "vue";
import { _ as V } from "../../../VHeadline.vue_vue_type_script_lang-186a5340.js";
import b from "../VIcon/VIcon.js";
import C from "../VText/VText.js";
import { useSpacingClass as v } from "../../../composables/useSpacingClass.js";
import { S as z } from "../../../Spacing-695d3b19.js";
import { _ as k } from "../../../_plugin-vue_export-helper-dad06003.js";
import "../../../composables/useShowPriceDisclaimer.js";
import "../../../utils/tailwindUnitsConverter.js";
const B = m({
  name: "VTextAndIcon",
  components: { VHeadline: V, VIcon: b, VText: C },
  data() {
    return {
      Spacing: z
    };
  },
  props: {
    headline: {
      type: String
    },
    subline: {
      type: String
    },
    icon: {
      type: String
    },
    text: {
      type: String
    },
    bottomSpacing: {
      type: String,
      default: "",
      validator: (e) => ["s", "m", "l", "xl", ""].includes(e)
    },
    topSpacing: {
      type: String,
      default: "",
      validator: (e) => ["s", "m", "l", "xl", ""].includes(e)
    },
    iconSize: {
      type: [String, Number],
      default: 120
    },
    iconViewBox: {
      type: String,
      default: "0 0 24 24"
    }
  },
  setup(e) {
    const { bottomSpacingClass: s, topSpacingClass: a } = v(e);
    return {
      cssClass: u(() => [
        e.bottomSpacing !== "" ? s.value : "",
        e.topSpacing !== "" ? a.value : ""
      ])
    };
  }
});
function w(e, s, a, p, x, T) {
  const r = i("VHeadline"), l = i("VIcon"), c = i("VText");
  return t(), d("div", {
    class: g(["tw-text-center", e.cssClass])
  }, [
    e.headline ? (t(), n(r, {
      key: 0,
      size: "s",
      title: e.headline,
      center: !0,
      "bottom-spacing": e.Spacing.l
    }, null, 8, ["title", "bottom-spacing"])) : o("", !0),
    e.icon ? (t(), n(l, {
      key: 1,
      symbol: e.icon,
      size: e.iconSize,
      role: "presentation",
      viewBox: e.iconViewBox
    }, null, 8, ["symbol", "size", "viewBox"])) : o("", !0),
    e.text ? (t(), n(c, {
      key: 2,
      size: "s",
      "top-spacing": e.icon ? e.Spacing.l : "",
      tag: "p"
    }, {
      default: S(() => [
        f(y(e.text), 1)
      ]),
      _: 1
    }, 8, ["top-spacing"])) : o("", !0),
    e.subline ? (t(), n(r, {
      key: 3,
      size: "xxs",
      title: e.subline,
      center: !0,
      "top-spacing": e.icon ? e.Spacing.l : void 0
    }, null, 8, ["title", "top-spacing"])) : o("", !0)
  ], 2);
}
const j = /* @__PURE__ */ k(B, [["render", w]]);
export {
  j as default
};
